var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { convertComplexRoutes } from './../helpers/ComplexRoutesConverter';
import trimStart from 'lodash/trimStart';
var ComplexRoutes = (function () {
    function ComplexRoutes() {
    }
    ComplexRoutes.prototype.addRoute = function (route) {
        var _this = this;
        var paths = trimStart(route.path, '/').split("/");
        console.log('addRoute', route, paths);
        var currentRoute = null;
        var currentChildren = this.routes;
        paths.forEach(function (path) {
            currentRoute = _this.getRouteWithPathInChildren(path, currentChildren);
            console.log('path', path, currentRoute, paths.indexOf(path), paths.length);
            if (!currentRoute) {
                if (paths.indexOf(path) === paths.length - 1) {
                    currentChildren.push(__assign(__assign({}, route), { path: path }));
                }
                else {
                    var newPath = {
                        path: path,
                        children: []
                    };
                    currentChildren.push(newPath);
                    currentChildren = newPath.children;
                }
            }
            else {
                currentRoute.children = currentChildren = (!currentRoute.children ? [] : currentRoute.children);
            }
        });
    };
    ComplexRoutes.prototype.addRawRouteAt = function (path, routes) {
        var currentChildren = this.getChildrenAtPath(path);
        console.log('addRawRouteAt', path, routes, currentChildren);
        currentChildren.push(routes);
    };
    ComplexRoutes.prototype.getChildrenAtPath = function (path) {
        var _this = this;
        var paths = trimStart(path, '/').split("/");
        console.log('getChildrenAtPath', path, paths);
        var currentRoute = null;
        var currentChildren = this.routes;
        paths.forEach(function (p) {
            currentRoute = _this.getRouteWithPathInChildren(p, currentChildren);
            console.log('path', p, currentRoute, paths.indexOf(p), paths.length);
            if (!p) {
            }
            else if (!currentRoute) {
                var newPath = {
                    path: p,
                    children: []
                };
                currentChildren.push(newPath);
                currentChildren = newPath.children;
            }
            else {
                currentRoute.children = currentChildren = (!currentRoute.children ? [] : currentRoute.children);
            }
        });
        return currentChildren;
    };
    ComplexRoutes.prototype.getRouteWithPathInChildren = function (path, children) {
        if (!children)
            return null;
        var res = null;
        children.some(function (child) {
            if (child.path === path) {
                res = child;
                return true;
            }
            return false;
        });
        return res;
    };
    ComplexRoutes.prototype.getConvertedRoutes = function () {
        console.log('complex routes:', this.routes);
        return convertComplexRoutes(this.routes);
    };
    return ComplexRoutes;
}());
export default ComplexRoutes;



//////////////////
// WEBPACK FOOTER
// ./src/modules/router/models/ComplexRoutes.ts
// module id = null
// module chunks = 